import React, { useEffect } from "react";
import ReactPaginate from "react-paginate";
import {
  Flex,
  Segment,
  Image,
  Text,
  Loader,
  Dialog,
  Input,
  Dropdown,
  Divider,
  Tooltip,
  Button,
  Box,
  // Status
} from "@fluentui/react-northstar";

import { CloseIcon, SearchIcon } from "@fluentui/react-icons-northstar";
import axios from "axios";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroller";

import TabMobileViewMenu from "./TabMobileViewMenu";
import StudentCard from "./StudentCard";
import userSvg from "../../../../Assets/images/svg/user.svg";

import "./StudentData.css";
import StudentProgressCard from "../../../Charts/Reports/StudentProgress/StudentProgressCard/StudentProgressCard";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";

const url = process.env.REACT_APP_EP_URL;

const inputItems = [20, 50, 100];

const chartTypes = {
  attendance: "attendance",
  assignment: "assignment",
  event: "event",
  feedback: "feedback",
};

const StudentData = (props) => {
  const { t } = useTranslation();
  const [state, setState] = React.useState({
    students: [],
    pageCount: 0,
  });
  const [load, setLoad] = React.useState(true);
  const [accDlg, setAccDlg] = React.useState(false);
  const [loadedInfo, setLoadedInfo] = React.useState(null);
  const [customFieldInfo, setCustomFieldInfo] = React.useState(null);
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(21);
  const [isScrollEnabled, setIsScrollEnabled] = React.useState(true);
  const [selectedChart, setSelectedChart] = React.useState(
    chartTypes.attendance
  );
  const [loader, setLoader] = React.useState(false);
  const [selectedStudent, setSelectedStudent] = React.useState(null);
  const [isFullScreen, setIsFullScreen] = React.useState(false);

  useEffect(() => {
    getAllStudent();
  }, []);

  const getAllStudent = (page = 1, limit = 21) => {
    axios
      .get(
        `${url}/api/admin/get-students-info${props.user.slug}&page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization: "Bearer " + props.user.accessToken,
          },
        }
      )
      .then((res) => {
        setPage(page);
        const response = res.data.result.rows;
        const pageCount = Math.ceil(res.data.result.count / limit);
        setIsScrollEnabled(page < pageCount);

        setState({
          // students: [...(state?.students || []), ...response
          students: [...response],
          pageCount,
        });

        setLoad(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          setAccDlg(true);
        }
      });
  };

  const getInfo = (email) => {
    setLoader(true);
    setLoadedInfo(null);
    setCustomFieldInfo(null);
    setSelectedChart(chartTypes.attendance);
    axios
      .put(
        `${url}/api/admin/get-student-info/${email}${props.user.slug}`,
        null,
        {
          headers: {
            Authorization: "Bearer " + props.user.accessToken,
          },
        }
      )
      .then((res) => {
        const response = res.data.result;
        const { assignment, feedback, event, info, chart } = res.data;
        setLoadedInfo({
          ...response,
          Ausente: response?.Ausente ?? 0,
          Justificado: response?.Justificado ?? 0,
          Presente: response?.Presente ?? 0,
          Retardo: response?.Retardo ?? 0,
          StudentEmailId: response?.StudentEmailId ?? "",
          StudentName: response?.StudentName ?? "",
          Total: response?.Total ?? 0,

          assignment: {
            total: assignment?.total ?? 0,
            reSubmit: assignment?.Resubmit ?? 0,
            completed: assignment?.Completed ?? 0,
            pending: assignment?.Pending ?? 0,
            gradesPending: assignment?.["Grades Pending"] ?? 0,
          },
          event: {
            registered: event?.registered ?? 0,
            bookmarked: event?.bookmarked ?? 0,
            organized: event?.organized ?? 0,
            total: event?.total ?? 0,
          },
          feedback: {
            total: feedback?.total ?? 0,
            poll: feedback?.poll ?? 0,
            text: feedback?.text ?? 0,
            audio: feedback?.audio ?? 0,
            video: feedback?.video ?? 0,
            mixed: feedback?.mixed ?? 0,
            any: feedback?.any ?? 0,
          },
          info: {
            ...info,
            subjects:
              info.subjects && Array.isArray(info.subjects)
                ? info.subjects
                : [],
            classNumber: info.classNumber ?? "",
            attendanceAverage: info.attendanceAverage ?? 0,
            assignmentAverage: info.assignmentAverage ?? 0,
          },
          chart,
        });
        setCustomFieldInfo(res.data.custom_field);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        toast.error(err?.response?.data?.message);
        console.log(err);

        if (err.response?.status === 401) {
          setAccDlg(true);
        }
      });
  };

  const onSearchStudentHandler = async (e) => {
    const value = e.target.value || "";
    axios
      .get(
        `${url}/api/admin/get-students-info${props.user.slug}&page=${page}&limit=${limit}&s=${value}`,
        {
          headers: {
            Authorization: "Bearer " + props.user.accessToken,
          },
        }
      )
      .then((res) => {
        const { rows, count } = res.data.result;
        const pageCount = Math.ceil(count / limit);
        setState({
          students: rows,
          pageCount,
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        console.log(err);
        if (err.response?.status === 401) {
          setAccDlg(true);
        }
      });
  };

  const handlePageClick = (data) => {
    setPage(data.selected + 1);
    const page = data.selected + 1;
    getAllStudent(page);
  };

  const chartSelectHandler = (type) => {
    setSelectedChart(type);
  };

  const scrollButtonHandler = (isScrollToRight) => {
    document.getElementById("scroll-statictics-container").scrollBy({
      left: isScrollToRight ? 150 : -150,
      top: 0,
      behavior: "smooth",
    });
  };

  return load ? (
    <Loader size="medium" style={{ paddingTop: "50px" }} />
  ) : (
    <>
      <div className="StudentData">
        <TabMobileViewMenu
          isTabletOrMobileView={props.isTabletOrMobileView}
          onSearchStudentHandler={onSearchStudentHandler}
        />
        <Dialog
          open={accDlg}
          onConfirm={() => location.reload()}
          confirmButton="Refresh Now"
          content={
            <p className="refreshMsg">{`${t("setting").student.info[7]}`}</p>
          }
          header="Authorization expire"
        />
        {/* <div className="filter-wrapper"> */}
        {/* {state.students.length > 0 ? ( */}
        <>
          {!props.isTabletOrMobileView && (
            <>
              <Flex space="around" vAlign="center" hAlign="center" wrap>
                <Input
                  icon={<SearchIcon />}
                  clearable
                  placeholder={t("setting").init[2]}
                  onChange={onSearchStudentHandler}
                />
                <ReactPaginate
                  previousLabel={t("setting").init[5]}
                  nextLabel={t("setting").init[4]}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={state.pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
                <Dropdown
                  items={inputItems}
                  placeholder={t("setting").init[6]}
                  checkable
                  getA11ySelectionMessage={{
                    onAdd: (item) => {
                      setLimit(item);
                      getAllStudent(page, item);
                    },
                  }}
                  className="SmallSelector"
                />
              </Flex>
              <Divider />
            </>
          )}
        </>
        {/* ) : (
        <p className="btsp text-center" style={{ margin: "50px auto" }}>
          Students are not available!
        </p>
      )} */}
        {/* </div> */}

        <Flex
          className="s-studentData "
          gap="gap.small"
          vAlign="center"
          hAlign="center"
          wrap
          style={{
            overflowY: "auto",
            position: "relative",
            maxHeight: props.isTabletOrMobileView
              ? "calc(100vh - 150px)"
              : // : "calc(100vh - 320px)",
                "calc(100vh - 290px)",
          }}
        >
          {props.isTabletOrMobileView ? (
            <>
              <InfiniteScroll
                pageStart={1}
                loadMore={() => {
                  getAllStudent(page + 1);
                }}
                hasMore={isScrollEnabled}
                loader={<Loader key={0} size="medium" />}
                useWindow={false}
                style={{ width: "100%" }}
              >
                <Grid
                  container
                  spacing={1}
                  style={{ justifyContent: "center", marginTop: "0px" }}
                >
                  {state.students.length > 0 ? (
                    state.students?.map((student, key) => {
                      return (
                        <StudentCard
                          student={student}                         
                          userSvg={userSvg}
                          props={props}
                          setSelectedStudent={setSelectedStudent}
                          isMobileView={props.isMobileView}
                        />
                      );
                    })
                  ) : (
                    <p
                      className="btsp text-center"
                      style={{ margin: "50px auto" }}
                    >
                      {`${t("setting").student.info[8]}`}
                    </p>
                  )}
                </Grid>
              </InfiniteScroll>
              {!isScrollEnabled && (
                <p className="btsp text-center" style={{ margin: "50px auto" }}>
                  {`${t("setting").student.info[9]}`}
                </p>
              )}
            </>
          ) : state.students.length > 0 ? (
            state.students?.map((student, key) => {
              return (
                <Segment
                  key={`Student-card-${key}`}
                  content={
                    <Flex style={{ flexDirection: "column" }}>
                      <Image
                        src={
                          student.studPhoto.Foto
                            ? props.user.slug === "?slug=acvpreprod" ||
                              props.user.slug === "?slug=acvapp"
                              ? student.studPhoto.Foto
                              : student.studPhoto.Foto + props.user.SASToken
                            : userSvg
                        }
                        className="m-img"
                      />
                      <Text
                        content={student.StudentName}
                        className="Karla fw6 m1 tcap"
                      />
                    </Flex>
                  }
                  style={{ width: "228px", height: "260px" }}
                  className="seg"
                  onClick={() =>
                    setSelectedStudent({
                      header:
                        student?.StudentName ||
                        student.StudentEmailID.split("@")[0],
                      image: student?.studPhoto?.Foto
                        ? student.studPhoto.Foto + props.user.SASToken
                        : userSvg,
                      content: student,
                      key: student.StudentEmailID,
                    })
                  }
                  title={student.StudentEmailID}
                />
              );
            })
          ) : (
            <p className="btsp text-center" style={{ margin: "50px auto" }}>
              {`${t("setting").student.info[8]}`}
            </p>
          )}
        </Flex>
      </div>
      <Dialog
        className={`student-report-model ${
          isFullScreen ? "full-screen-dialog" : ""
        }`}
        open={selectedStudent !== null}
        confirmButton={t("setting").init[3]}
        onConfirm={() => {
          setSelectedStudent(null);
          setIsFullScreen(false);
        }}
        header={
          <Box>
            <Flex space="between" vAlign="center">
              <Text content={selectedStudent?.header || ""} weight="semibold" />
              <Tooltip
                content={isFullScreen ? "Exit Full Screen" : "Full Screen"}
                styles={{
                  boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
                }}
                trigger={
                  <Button
                    text
                    iconOnly
                    icon={
                      isFullScreen ? (
                        <FullscreenExitOutlined style={{ fontSize: "14px" }} />
                      ) : (
                        <FullscreenOutlined style={{ fontSize: "14px" }} />
                      )
                    }
                    onClick={() => setIsFullScreen(!isFullScreen)}
                    styles={{
                      height: "fit-content",
                    }}
                    aria-label={
                      isFullScreen ? "Exit Full Screen" : "Full Screen"
                    }
                  />
                }
                zIndex={10}
                mountNode={
                  document.getElementsByClassName("student-report-model")[0]
                }
              />
            </Flex>
          </Box>
        }
        content={
          <StudentProgressCard
            user={props.user}
            isTabletOrMobileView={props.isTabletOrMobileView}
            isMobileView={props.isMobileView}
            isTabletView={props.isTabletView}
            selectedStudent={selectedStudent}
          />
        }
        headerAction={{
          icon: <CloseIcon />,
          title: "Close",
          onClick: () => {
            setSelectedStudent(null);
            setIsFullScreen(false);
          },
        }}
      />
    </>
  );
};

export default StudentData;
